import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Replaced react-bootstrap Dropdowns with MUI Autocomplete
import { useParams } from 'react-router-dom';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import MainLayout from "../components/layout/MainLayout";
import './page.css'
import { Modal, Card, Typography, FormControl, MenuItem, TextField, Button, Select, Container, Stack, Autocomplete, Fade, Paper } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import ReportIcon from '@mui/icons-material/Report';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
// KaTeX dependency
import "katex/dist/katex.css";
// Quill dependency
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
// MathQuill dependency
import "./jquery";
import "@edtr-io/mathquill/build/mathquill.js";
import "@edtr-io/mathquill/build/mathquill.css";
// mathquill4quill include
import "mathquill4quill/mathquill4quill.css";
import RichHtml from '../components/editor/RichHtml';
import { useMathQuillInit } from '../components/editor/useMathQuillInit';
import ClearIcon from '@mui/icons-material/Clear';
import './default.css'
//APIs
import { fetchCategoryAsync } from '../redux/reducer/category/categorySlice';
import { fetchCourseByCategoryAsync } from '../redux/reducer/courses/courseSlice';
import { fetchYearAsync } from '../redux/reducer/years/yearSlice';
import { fetchTopicsByCourseIdAsync } from '../redux/reducer/topics/topicSlice';
import { fetchQuestionAsync } from '../redux/reducer/questions/questionSlice';
import { createQuestionAsync } from '../redux/reducer/questions/questionSlice';
import { deleteQuestionAsync } from '../redux/reducer/questions/questionSlice';
import { updateQuestionAsync } from '../redux/reducer/questions/questionSlice';
import { fetchSchoolsAsync } from '../redux/reducer/schools/schoolSlice';
import katex from "katex";
import { uploadToFileStorage } from '../utils/cloudinary';
window.katex = katex;

const Question = () => {

  const { appId } = useParams();
  const dispatch = useDispatch();
  const menuItems = ['Option A', 'Option B', 'Option C', 'Option D', 'Option E', 'Option F', 'Option G'];

  const categories = useSelector((state) => state.category.list);
  const courses = useSelector((state) => state.course.list);
  const topics = useSelector((state) => state.topic.list);
  const years = useSelector((state) => state.year.list);
  const schools = useSelector((state) => state.school.list);
  const questions = useSelector((state) => state.question.list);
  const loading = useSelector((state) => state.question.loading);

  const [open, setOpen] = useState(false);
  const [SelectedCourse, setSelectedCourse] = useState(null);
  const [SelectedCategory, setSelectedCategory] = useState(null);
  const [SelectedYear, setSelectedYear] = useState(null);
  const [SelectedSchool, setSelectedSchool] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [SelectedTopic, setSelectedTopic] = useState(null);
  const [fetchedQuestion, setFetchedQuestion] = useState(null);
  const [SelectedQuestion, setSelectedQuestion] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [saved, setSaved] = useState(false); // New state for saved

  //Add Question
  const [questionasked, setQuestionAsked] = useState('');
  const [questionType, setQuestionType] = useState('subjective');
  const [answerType, setAnswerType] = useState('text');
  const [options, setOptions] = useState([""]);
  const [answer, setAnswer] = useState(menuItems[0]);
  const [solution, setSolution] = useState('');
  const initMathQuill = useMathQuillInit();
  const quillFormats = useMemo(() => (
    ['bold','italic','underline','strike','script','header','color','background','blockquote','list','bullet','link','image','video','code-block','formula']
  ), []);
  const quillModules = useMemo(() => ({
    formula: true,
    toolbar: [
      ["video", "bold", "italic", "strike", "underline", "formula", "image", "color", "code-block"],
      [{ script: "sub" }, { script: "super" }],
      ["link"],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }, { background: [] }],
      ['blockquote'],
      [{ list: "ordered" }, { list: "bullet" }],
      ['clean']
    ]
  }), []);

  useEffect(() => {
    dispatch(fetchCategoryAsync(appId));
  }, [dispatch, appId]);

  useEffect(() => {
    dispatch(fetchYearAsync(appId));
  }, [dispatch, appId]);

  useEffect(() => {
    dispatch(fetchSchoolsAsync());
  }, [dispatch]);

  // useEffect(() => {
  //   // if (isFetching) {
  //     dispatch(fetchQuestionAsync(appId, SelectedCategory, SelectedYear, SelectedCourse, SelectedTopic));
  //     // setIsFetching(false);
  //   // }
  // }, [dispatch, isFetching]);



  if (!courses) {
    return <Box>Loading...</Box>;
  }


  const handleQuestionChange = (newContent) => {
    setQuestionAsked(newContent);
  };
  const handleOptionChange = (index, value) => {
    const updatedOptions = [...options];
    updatedOptions[index] = value;
    setOptions(updatedOptions);
  };

  const addOptionField = () => {
    setOptions([...options, '']);
  };

  const removeOptionField = (index) => {
    const updatedOptions = [...options];
    updatedOptions.splice(index, 1);
    setOptions(updatedOptions);
  };

  const handleCorrectionChange = (newContent) => {
    setSolution(newContent);
  };

  const handleImageChange = (event) => {
    setSelectedImage(event.target.files[0]);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const openEditModal = (question) => {
    setSelectedQuestion(question)
    // Set the selected school if question has one
    if (question.school) {
      setSelectedSchool(question.school);
    } else {
      setSelectedSchool(null);
    }
    console.log(question)
    setIsEditModalOpen(true);
  };

  // Function to close the edit modal
  const closeEditModal = () => {
    setSelectedQuestion(null)
    setIsEditModalOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
    setSaved(false)
    setOptions(['Option A'])
    setQuestionAsked('');
    setQuestionType('subjective');
    setAnswer(menuItems[0]);
    setSolution('');

  };
  const handleOpenDeleteModal = (question) => {
    setSelectedQuestion(question);
    console.log(SelectedQuestion)
    console.log(appId)
    setOpenDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };


  const handleCourseSelection = (courseObj) => {
    const id = courseObj?._id || null;
    setSelectedCourse(id);
    if (id) {
      dispatch(fetchTopicsByCourseIdAsync(appId, id));
    }
  };
  const handleTopicSelection = (topicObj) => {
    const id = topicObj?._id || null;
    setSelectedTopic(id);
  };
  const handleYearSelection = (yearObj) => {
    const id = yearObj?._id || null;
    setSelectedYear(id);
  };
  const handleCategorySelection = (categoryObj) => {
    const id = categoryObj?._id || null;
    setSelectedCategory(id);
    // reset dependent selections
    setSelectedCourse(null);
    setSelectedTopic(null);
    if (id) {
      dispatch(fetchCourseByCategoryAsync(appId, id));
    }
  };

  const handleSchoolSelection = (schoolObj) => {
    const id = schoolObj?._id || null;
    setSelectedSchool(id);
    setSelectedQuestion({ ...SelectedQuestion, school: id || null });
  };



  const getSelectedCourseCode = () => {
    const course = courses.find((course) => course._id === SelectedCourse);
    return course ? course.code : 'Select a Course';
  };
  const getYear = () => {
    const year = years.find((year) => year._id === SelectedYear);
    return year ? year.year : 'Select a Year';
  };
  const getTopic = () => {
    const topic = topics.find((topic) => topic._id === SelectedTopic);
    return topic ? topic.title.substring(0, 15) + '...' : 'Select a Topic';
  };

  //Fetch Questions
  const handleFetchQuestions = () => {
    if (SelectedYear && SelectedCourse && SelectedTopic) {
      dispatch(fetchQuestionAsync(appId, SelectedCategory, SelectedYear, SelectedCourse, SelectedTopic, SelectedSchool))
      // console.log(`${appId} ${SelectedCourse} ${SelectedYear}${SelectedTopic}`)
      setFetchedQuestion(questions)
    } else {
      console.log('Select a course')
      alert('Select all fields including school to fetch questions')
    }
  }
  const qaddOptionField = () => {
    setSelectedQuestion((prevQuestion) => ({
      ...prevQuestion,
      options: [...prevQuestion.options, ''] // Add an empty option to the options array
    }));
  };

  const qremoveOptionField = (index) => {
    setSelectedQuestion((prevQuestion) => {
      const updatedOptions = [...prevQuestion.options];
      updatedOptions.splice(index, 1); // Remove the option at the specified index
      return {
        ...prevQuestion,
        options: updatedOptions
      };
    });
  };
  const handleCreateQuestion = async (e) => {
    e.preventDefault()
    if (SelectedCourse && SelectedYear && SelectedTopic && questionasked && answer) {
      const div = document.createElement("div");
      const div2 = document.createElement("div");
      div.innerHTML = questionasked;
      div2.innerHTML = solution;

      const richTextElements = div.getElementsByClassName("ql-editor");
      for (let i = 0; i < richTextElements.length; i++) {
        const richTextContent = richTextElements[i].innerHTML;
        richTextElements[i].innerHTML = richTextContent;
      }
      const formulaElements = div.getElementsByClassName("ql-formula");
      for (let i = 0; i < formulaElements.length; i++) {
        const dataValue = formulaElements[i].getAttribute("data-value");
        const latex = dataValue ? `$$${dataValue}$$` : "";
        formulaElements[i].textContent = latex;
      }
      if (selectedImage) {
        try {
          const data = await uploadToFileStorage(selectedImage,{
            folder: `questions`,
          })
          // Handle the response from Cloudinary after successful upload
          const image = data.url

          const questionData = {
            questionasked,
            questionType,
            options,
            answer,
            solutionType: answerType,
            solution: image,
            school: SelectedSchool || null,
          };
          // Call the onAddQuestion prop to add the question
          dispatch(createQuestionAsync({ appId, categoryId: SelectedCategory, yearId: SelectedYear, courseId: SelectedCourse, topicId: SelectedTopic, questionData: questionData }))
            .then(() => {
              setSaved(true)
              setSelectedImage(null)
            })
          dispatch(fetchQuestionAsync(appId, SelectedCategory, SelectedCategory, SelectedYear, SelectedCourse, SelectedTopic))
          console.log(questionData)
        } catch (err) {

        }
      } else {
        const questionData = {
          questionasked,
          questionType,
          options,
          answer,
          solutionType: answerType,
          solution,
          school: SelectedSchool || null,
        };
        // Call the onAddQuestion prop to add the question
        dispatch(createQuestionAsync({ appId, categoryId: SelectedCategory, yearId: SelectedYear, courseId: SelectedCourse, topicId: SelectedTopic, questionData: questionData }))
          .then(() => {
            setSaved(true)
            setSelectedImage(null)
            dispatch(fetchQuestionAsync(appId, SelectedCategory, SelectedYear, SelectedCourse, SelectedTopic))
          })

        console.log(questionData)
      }
    } else {
      alert("Select and input the required fields")
      setSaved(false)
    }
    dispatch(fetchQuestionAsync(appId, SelectedCategory, SelectedYear, SelectedCourse, SelectedTopic))
  }
  const handleDeleteQuestion = () => {
    if (SelectedQuestion) {
      dispatch(deleteQuestionAsync({ appId, questionId: SelectedQuestion }));
      console.log(`deleted ${SelectedQuestion}`)
      dispatch(fetchQuestionAsync(appId, SelectedCategory, SelectedYear, SelectedCourse, SelectedTopic))
      handleCloseDeleteModal();
    }
  };

  const handleUpdateQuestion = async (event) => {
    event.preventDefault();

    if (SelectedQuestion) {
      // Check if the question type is "objective"
      if (SelectedQuestion.questionType === "subjective") {
        // Set the options array to null
        setSelectedQuestion(prevState => ({
          ...prevState,
          options: [""]
        }));
      }
      if (selectedImage) {
        
        try {
          const data = await uploadToFileStorage(selectedImage,{
            folder: `questions`,
          })
          // Handle the response from Cloudinary after successful upload
          const image = data.url;

          console.log(SelectedQuestion.solution)
          console.log(image)
          SelectedQuestion.solution = image;
          // Call the onAddQuestion prop to add the question
          dispatch(updateQuestionAsync({ appId, categoryId: SelectedCategory, yearId: SelectedYear, courseId: SelectedCourse, topicId: SelectedTopic, questionId: SelectedQuestion._id, questionData: SelectedQuestion }))
            .then((updatedQuestion) => {

              // Update the 'notes' state variable with the updated note data
              // setSelectedQuestion(updatedQuestion);
              // dispatch(fetchQuestionAsync(appId, SelectedCategory, SelectedYear, SelectedCourse, SelectedTopic))
              handleFetchQuestions()
              setSelectedSchool(null);
              setSaved(true);
             closeEditModal();
              setSelectedImage(null)

            })
            .catch((error) => {
              console.error(error);
              // Handle error if necessary
            });
          // dispatch(fetchQuestionAsync(appId, SelectedCategory, SelectedYear, SelectedCourse, SelectedTopic))
          // console.log(SelectedQuestion)
          // handleFetchQuestions()
        }
        catch (err) {
          console.log(err)
        }
      }
      else {


        dispatch(updateQuestionAsync({ appId, categoryId: SelectedCategory, yearId: SelectedYear, courseId: SelectedCourse, topicId: SelectedTopic, questionId: SelectedQuestion._id, questionData: SelectedQuestion }))
          .then((updatedQuestion) => {
            // if (updatedQuestion) {
            // Update the 'notes' state variable with the updated note data
            // setSelectedQuestion(null);
            handleFetchQuestions()
            setSelectedSchool(null);
            setSaved(true);
            closeEditModal();
            setSelectedImage(null)

            // }
          })
          .catch((error) => {
            console.error(error);
            // Handle error if necessary
          });

        dispatch(fetchQuestionAsync(appId, SelectedYear, SelectedCourse, SelectedTopic))

      }

    }
    setSelectedImage(null)
  }

  return (
    <MainLayout>
      <Container maxWidth="xl">
        <Box sx={{ mb: 4 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            <Box>
              <Typography
                variant="h4"
                fontWeight="700"
                gutterBottom
                sx={{
                  background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                Questions
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Manage past questions and assessments
              </Typography>
            </Box>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleOpen}
              sx={{
                borderRadius: 2,
                px: 3,
                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
                },
              }}
            >
              Add Question
            </Button>
          </Stack>
        </Box>
      {/**Add Question Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box style={{ 
          position: 'absolute', 
          top: '50%', 
          left: '50%', 
          transform: 'translate(-50%, -50%)', 
          width: "90%",
          maxWidth: 800,
          maxHeight: '90vh',
          backgroundColor: 'white', 
          borderRadius: 8, 
          padding: 16, 
          overflow: 'auto' 
        }}>
          <Typography variant="h6" style={{ marginBottom: "0.5rem" }}>Add Question</Typography>
          <Box style={{ display: "flex", gap: 8, alignItems: "center", justifyContent: "center", paddingBottom: "1rem", flexWrap: 'wrap' }} >
            <Autocomplete
              options={Array.isArray(categories) ? categories : []}
              getOptionLabel={(option) => option?.category || ''}
              value={(Array.isArray(categories) ? categories : []).find((c) => c._id === SelectedCategory) || null}
              onChange={(e, value) => handleCategorySelection(value || null)}
              clearOnEscape
              disableClearable={false}
              sx={{ minWidth: 220 }}
              renderInput={(params) => (
                <TextField {...params} size="small" label="Category" placeholder="Select category" />
              )}
            />
            <Autocomplete
              options={SelectedCategory ? (Array.isArray(courses) ? courses : []) : []}
              getOptionLabel={(option) => option?.name || ''}
              value={(Array.isArray(courses) ? courses : []).find((c) => c._id === SelectedCourse) || null}
              onChange={(e, value) => handleCourseSelection(value || null)}
              clearOnEscape
              disableClearable={false}
              sx={{ minWidth: 240 }}
              renderInput={(params) => (
                <TextField {...params} size="small" label="Course" placeholder="Select course" />
              )}
            />
            <Autocomplete
              options={Array.isArray(years) ? years : []}
              getOptionLabel={(option) => option?.year?.toString() || ''}
              value={(Array.isArray(years) ? years : []).find((y) => y._id === SelectedYear) || null}
              onChange={(e, value) => handleYearSelection(value || null)}
              clearOnEscape
              disableClearable={false}
              sx={{ minWidth: 180 }}
              renderInput={(params) => (
                <TextField {...params} size="small" label="Year" placeholder="Select year" />
              )}
            />
            <Autocomplete
              options={SelectedCourse ? (Array.isArray(topics) ? topics : []) : []}
              getOptionLabel={(option) => option?.title || ''}
              value={(Array.isArray(topics) ? topics : []).find((t) => t._id === SelectedTopic) || null}
              onChange={(e, value) => handleTopicSelection(value || null)}
              clearOnEscape
              disableClearable={false}
              sx={{ minWidth: 240 }}
              renderInput={(params) => (
                <TextField {...params} size="small" label="Topic" placeholder="Select topic" />
              )}
            />
            <Autocomplete
              options={Array.isArray(schools) ? schools : []}
              getOptionLabel={(option) => option ? `${option.name}${option.code ? ` (${option.code})` : ''}` : ''}
              value={(Array.isArray(schools) ? schools : []).find((s) => s._id === SelectedSchool) || null}
              onChange={(e, value) => handleSchoolSelection(value || null)}
              clearOnEscape
              disableClearable={false}
              sx={{ minWidth: 260 }}
              renderInput={(params) => (
                <TextField {...params} size="small" label="School (optional)" placeholder="Select school" />
              )}
            />
          </Box>
          <ReactQuill
            ref={initMathQuill}
            id="editor"
            margin="normal"
            fullWidth
            style={{ minHeight: 200, maxHeight: 400, overflow: 'auto' }}
            modules={quillModules}
            formats={quillFormats}
            value={questionasked}
            onChange={handleQuestionChange}
            placeholder="Enter question"
            theme="snow"
          />
          <Typography>Question Type</Typography>
          <FormControl>
            <Select value={questionType} required
              labelId="question-type-label"
              id="question-type" onChange={(event) => setQuestionType(event.target.value)}>
              <MenuItem value="subjective">Subjective</MenuItem>
              <MenuItem value="objective">Objective</MenuItem>
            </Select>
          </FormControl>
          {questionType === 'objective' && (
            <Box style={{ paddingTop: "1rem" }}>
              <Typography>Options</Typography>

              <Box style={{ display: 'flex', flexWrap: "wrap", }}>
                {options.map((option, index) => (
                  <Box key={index} style={{ display: 'flex', marginRight: '10px', marginBottom: '10px', }}>
                    <TextField
                      label={`Option ${index + 1}`}

                      value={option}
                      onChange={(e) => handleOptionChange(index, e.target.value)}
                      required
                    />
                    {index > 0 && (
                      <ClearIcon onClick={() => removeOptionField(index)} />
                    )}
                  </Box>
                ))}
              </Box>
              <Button variant="contained" color="primary" onClick={addOptionField}>
                <AddIcon /> Option
              </Button>
              <Box>
                <Typography>Answer</Typography>

                <Select
                  id="answer"
                  value={answer} style={{ marginTop: "1rem" }}
                  onChange={(e) => setAnswer(e.target.value)}
                >
                  {menuItems.slice(0, options.length).map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </Box>
          )}
          {questionType === "subjective" && (
            <TextField
              id="answer"
              label="Answer"
              style={{ marginLeft: "1rem" }}
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
            />
          )}


          <Typography>Solution Type</Typography>
          <FormControl>
            <Select value={answerType} required
              labelId="question-type-label"
              id="question-type" onChange={(event) => setAnswerType(event.target.value)}>
              <MenuItem value="text">Text</MenuItem>
              <MenuItem value="image">Image</MenuItem>
            </Select>
          </FormControl>
          <Typography>Solution</Typography>

          {answerType === "text" && (
            <ReactQuill
              ref={initMathQuill}
              id="editor"
              margin="normal"
              fullWidth
              style={{ minHeight: 160, maxHeight: 320, overflow: 'auto', marginBottom: "0.5rem", marginTop: "0.5rem" }}
              modules={quillModules}
              formats={quillFormats}
              value={solution}
              onChange={handleCorrectionChange}
              placeholder="Enter Solution"
              theme="snow"
            />
          )}

          {answerType === "image" && (
            <input type="file" accept="image/*" style={{ margin: "0.8rem" }} onChange={handleImageChange} />
          )}


          <Button variant="contained" style={{ background: "#540a61" }} onClick={handleCreateQuestion}>
            {loading ? 'Saving...' : saved ? 'Saved Successfully' : 'Save'}
          </Button>
          <Button variant="contained" style={{ background: "red", marginLeft: "1rem" }} onClick={handleClose}>
            Cancel
          </Button>
        </Box>
      </Modal>

      {/**Page */}
      <Box>
        <Typography variant='h5' fontWeight="700">Past Questions</Typography>
        <Box style={{ padding: "1rem", borderRadius: "5px" }}>
          <Box style={{ display: "flex", gap: 8, alignItems: "center", justifyContent: "center", paddingBottom: "1rem", flexWrap: 'wrap' }}>
            <Autocomplete
              options={Array.isArray(categories) ? categories : []}
              getOptionLabel={(option) => option?.category || ''}
              value={(Array.isArray(categories) ? categories : []).find((c) => c._id === SelectedCategory) || null}
              onChange={(e, value) => handleCategorySelection(value || null)}
              clearOnEscape
              disableClearable={false}
              sx={{ minWidth: 220 }}
              renderInput={(params) => (
                <TextField {...params} size="small" label="Category" placeholder="Select category" />
              )}
            />
            <Autocomplete
              options={SelectedCategory ? (Array.isArray(courses) ? courses : []) : []}
              getOptionLabel={(option) => option?.name || ''}
              value={(Array.isArray(courses) ? courses : []).find((c) => c._id === SelectedCourse) || null}
              onChange={(e, value) => handleCourseSelection(value || null)}
              clearOnEscape
              disableClearable={false}
              sx={{ minWidth: 240 }}
              renderInput={(params) => (
                <TextField {...params} size="small" label="Course" placeholder="Select course" />
              )}
            />
            <Autocomplete
              options={Array.isArray(years) ? years : []}
              getOptionLabel={(option) => option?.year?.toString() || ''}
              value={(Array.isArray(years) ? years : []).find((y) => y._id === SelectedYear) || null}
              onChange={(e, value) => handleYearSelection(value || null)}
              clearOnEscape
              disableClearable={false}
              sx={{ minWidth: 180 }}
              renderInput={(params) => (
                <TextField {...params} size="small" label="Year" placeholder="Select year" />
              )}
            />
            <Autocomplete
              options={SelectedCourse ? (Array.isArray(topics) ? topics : []) : []}
              getOptionLabel={(option) => option?.title || ''}
              value={(Array.isArray(topics) ? topics : []).find((t) => t._id === SelectedTopic) || null}
              onChange={(e, value) => handleTopicSelection(value || null)}
              clearOnEscape
              disableClearable={false}
              sx={{ minWidth: 240 }}
              renderInput={(params) => (
                <TextField {...params} size="small" label="Topic" placeholder="Select topic" />
              )}
            />
            <Autocomplete
              options={Array.isArray(schools) ? schools : []}
              getOptionLabel={(option) => option ? `${option.name}${option.code ? ` (${option.code})` : ''}` : ''}
              value={(Array.isArray(schools) ? schools : []).find((s) => s._id === SelectedSchool) || null}
              onChange={(e, value) => setSelectedSchool(value?._id || null)}
              clearOnEscape
              disableClearable={false}
              sx={{ minWidth: 260 }}
              renderInput={(params) => (
                <TextField {...params} size="small" label="School (optional)" placeholder="Select school" />
              )}
            />
          </Box>
          <Button variant='contained' style={{ background: "#540a61" }} onClick={handleFetchQuestions} >Fetch Past Questions</Button>
        </Box>

        <Card style={{ marginTop: "2rem" }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow style={{ fontWeight: "600", borderBottom: "3px solid #8a898f" }}>
                  <TableCell>S/N</TableCell>
                  <TableCell>Question</TableCell>
                  <TableCell>Course Code</TableCell>
                  <TableCell>Year</TableCell>
                  <TableCell>Topic</TableCell>
                  <TableCell>School</TableCell>
                  <TableCell>Answer</TableCell>
                  <TableCell>Solution</TableCell>
                  <TableCell colSpan="2">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody >
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : fetchedQuestion ? (
                  questions.length > 0 ? (
                    questions.map((question, index) => (
                      <TableRow key={question._id} style={{ fontWeight: "600", borderBottom: "3px solid #8a898f" }}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell><RichHtml html={question.questionasked} /></TableCell>
                        <TableCell>{getSelectedCourseCode()}</TableCell>
                        <TableCell>{getYear()}</TableCell>
                        <TableCell>{getTopic()}</TableCell>
                        <TableCell>{question.school ? (question.school.code || 'N/A') : '-'}</TableCell>
                        <TableCell><RichHtml html={question.answer} /></TableCell>
                        <TableCell><RichHtml html={question.solution} /></TableCell>
                        <TableCell>
                          <Button variant='contained' style={{ background: "blue" }} onClick={() => openEditModal(question)}><EditCalendarIcon /> </Button> &nbsp;
                          <Button variant='contained' style={{ background: "red" }} onClick={() => handleOpenDeleteModal(question._id)}><DeleteForeverIcon background="red" /> </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <Typography fontWeight="500">Oops! You have no question for this Option</Typography>
                      </TableCell>
                    </TableRow>
                  )) : (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <Typography fontWeight="400">Please Select an Option</Typography>
                    </TableCell>
                  </TableRow>
                )
                }
              </TableBody>
            </Table>
          </TableContainer>
        </Card>

       

        <Modal open={openDeleteModal} onClose={handleCloseDeleteModal} sx={{ backdropFilter: 'blur(4px)' }}>
          <Fade in={openDeleteModal}>
            <Paper
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: { xs: '90%', sm: 400 },
                borderRadius: 3,
                boxShadow: 24,
                textAlign: 'center',
                p: 4,
              }}
            >
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: '50%',
                  backgroundColor: 'rgba(239, 68, 68, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 16px',
                }}
              >
                <ReportIcon sx={{ fontSize: 32, color: 'error.main' }} />
              </Box>
              <Typography variant="h6" fontWeight="600" gutterBottom>
                Delete Question?
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Are you sure you want to delete this question? This action cannot be undone.
              </Typography>
              <Stack direction="row" spacing={2} justifyContent="center">
                <Button variant="outlined" onClick={handleCloseDeleteModal}>
                  Cancel
                </Button>
                <Button variant="contained" color="error" onClick={handleDeleteQuestion} startIcon={<DeleteForeverIcon />}>
                  Delete
                </Button>
              </Stack>
            </Paper>
          </Fade>
        </Modal>
      </Box>


      {/**Edit Question Modal */}

      {SelectedQuestion && (
        <Modal open={isEditModalOpen} onClose={closeEditModal}>
          <Box style={{ 
            position: 'absolute', 
            top: '50%', 
            left: '50%', 
            transform: 'translate(-50%, -50%)', 
            width: "90%",
            maxWidth: 800,
            maxHeight: '90vh',
            backgroundColor: 'white', 
            borderRadius: 8, 
            padding: 16, 
            overflow: 'auto' 
          }}>
            <Typography variant="h6" style={{ marginBottom: "0.5rem" }}>Edit Question</Typography>
            <Box style={{ display: "flex", gap: 8, alignItems: "center", justifyContent: "center", paddingBottom: "1rem", flexWrap: 'wrap' }} >
              <Autocomplete
                options={Array.isArray(categories) ? categories : []}
                getOptionLabel={(option) => option?.category || ''}
                value={(Array.isArray(categories) ? categories : []).find((c) => c._id === SelectedCategory) || null}
                onChange={(e, value) => handleCategorySelection(value || null)}
                clearOnEscape
                disableClearable={false}
                sx={{ minWidth: 220 }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="Category" placeholder="Select category" />
                )}
              />
              <Autocomplete
                options={SelectedCategory ? (Array.isArray(courses) ? courses : []) : []}
                getOptionLabel={(option) => option?.name || ''}
                value={(Array.isArray(courses) ? courses : []).find((c) => c._id === SelectedCourse) || null}
                onChange={(e, value) => handleCourseSelection(value || null)}
                clearOnEscape
                disableClearable={false}
                sx={{ minWidth: 240 }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="Course" placeholder="Select course" />
                )}
              />
              <Autocomplete
                options={Array.isArray(years) ? years : []}
                getOptionLabel={(option) => option?.year?.toString() || ''}
                value={(Array.isArray(years) ? years : []).find((y) => y._id === SelectedYear) || null}
                onChange={(e, value) => handleYearSelection(value || null)}
                clearOnEscape
                disableClearable={false}
                sx={{ minWidth: 180 }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="Year" placeholder="Select year" />
                )}
              />
              <Autocomplete
                options={SelectedCourse ? (Array.isArray(topics) ? topics : []) : []}
                getOptionLabel={(option) => option?.title || ''}
                value={(Array.isArray(topics) ? topics : []).find((t) => t._id === SelectedTopic) || null}
                onChange={(e, value) => handleTopicSelection(value || null)}
                clearOnEscape
                disableClearable={false}
                sx={{ minWidth: 240 }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="Topic" placeholder="Select topic" />
                )}
              />
              <Autocomplete
                options={Array.isArray(schools) ? schools : []}
                getOptionLabel={(option) => option ? `${option.name}${option.code ? ` (${option.code})` : ''}` : ''}
                value={(Array.isArray(schools) ? schools : []).find((s) => s._id === SelectedSchool) || null}
                onChange={(e, value) => handleSchoolSelection(value || null)}
                clearOnEscape
                disableClearable={false}
                sx={{ minWidth: 260 }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="School (optional)" placeholder="Select school" />
                )}
              />
            </Box>

            <ReactQuill
              ref={initMathQuill}
              id="editor"
              margin="normal"
              fullWidth
              style={{ minHeight: 160, maxHeight: 320, overflow: 'auto', marginBottom: "0.5rem", marginTop: "0.5rem" }}
              modules={quillModules}
              formats={quillFormats}
              value={SelectedQuestion.questionasked}
              onChange={(value) => setSelectedQuestion({ ...SelectedQuestion, questionasked: value })}
              placeholder="Enter question"
              theme="snow"
            />
            <Typography>Question Type</Typography>
            <FormControl>
              <Select value={SelectedQuestion.questionType} required
                labelId="question-type-label"
                id="question-type"
                onChange={(event) => setSelectedQuestion({ ...SelectedQuestion, questionType: event.target.value })}>
                <MenuItem value="subjective">Subjective</MenuItem>
                <MenuItem value="objective">Objective</MenuItem>
              </Select>
            </FormControl>
            {SelectedQuestion.questionType === 'objective' && (
              <Box style={{ paddingTop: "1rem" }}>
                <Typography>Options</Typography>

                <Box style={{ display: 'flex', flexWrap: "wrap", }}>
                  {SelectedQuestion.options.map((option, index) => (
                    <Box key={index} style={{ display: 'flex', marginRight: '10px', marginBottom: '10px', }}>
                      <TextField
                        label={`Option ${index + 1}`}

                        value={SelectedQuestion.options[index]}
                        onChange={(e) => {
                          const updatedOptions = [...SelectedQuestion.options];
                          updatedOptions[index] = e.target.value;
                          setSelectedQuestion(prevState => ({
                            ...prevState,
                            options: updatedOptions
                          }));
                        }}
                      />
                      {index > 0 && (
                        <ClearIcon onClick={() => qremoveOptionField(index)} />
                      )}
                    </Box>
                  ))}
                </Box>
                <Button variant="contained" color="primary" onClick={qaddOptionField}>
                  <AddIcon /> Option
                </Button>
                <Box>
                  <Select
                    id="answer"
                    value={SelectedQuestion.answer}
                    style={{ marginTop: "1rem" }}
                    onChange={(e) => setSelectedQuestion({ ...SelectedQuestion, answer: e.target.value })}
                  >
                    {menuItems.slice(0, SelectedQuestion.options.length).map((item, index) => (
                      <MenuItem key={index} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>
            )}
            {SelectedQuestion.questionType === "subjective" && (
              <TextField
                id="answer"
                label="Answer"

                style={{ marginLeft: "1rem" }}
                value={SelectedQuestion.answer}
                onChange={(e) => setSelectedQuestion({ ...SelectedQuestion, answer: e.target.value })}
              />
            )}


            <Typography>Solution Type</Typography>
            <FormControl>
              <Select value={SelectedQuestion.solutionType} required
                labelId="question-type-label"
                id="question-type" onChange={(event) => setSelectedQuestion({ ...SelectedQuestion, solutionType: event.target.value })}>
                <MenuItem value="text">Text</MenuItem>
                <MenuItem value="image">Image</MenuItem>
              </Select>
            </FormControl>
            <Typography>Solution</Typography>

            {SelectedQuestion.solutionType === "text" && (
              <ReactQuill
                ref={initMathQuill}
                id="editor"
                margin="normal"
                fullWidth
                style={{ minHeight: 160, maxHeight: 320, overflow: 'auto', marginBottom: "0.5rem", marginTop: "0.5rem" }}
                modules={quillModules}
                formats={quillFormats}
                value={SelectedQuestion.solution}
                onChange={(value) => {
                  setSelectedQuestion((prevQuestion) => ({
                    ...prevQuestion,
                    solution: value
                  }));
                }}
                placeholder="Enter Solution"
                theme="snow"
              />
            )}

            {SelectedQuestion.solutionType === "image" && (
              <Box>
                <img src={SelectedQuestion.solution} alt="question pic" style={{ width: 100, height: 100 }} />
                <input type="file" accept="image/*" style={{ margin: "0.8rem" }} onChange={handleImageChange} />
              </Box>
            )}    <Button variant="contained" style={{ background: "#540a61" }} onClick={handleUpdateQuestion}>
              {loading ? 'Saving...' : saved ? 'Saved Successfully' : 'Save'}
            </Button>
            <Button variant="contained" style={{ background: "red", marginLeft: "1rem" }} onClick={closeEditModal}>
              Cancel
            </Button>
          </Box>
        </Modal>
      )}
      </Container>
    </MainLayout>
  )
}

export default Question
